import authorizeLoader from "@/modules/authorize/loader";
import * as actions from "./data/actions";
import * as loaders from "./data/loaders";
import ProjectsError from "./error";

import statementsRoutes from "./statements/routes";
import {
  AiAnalysisView,
  CreateView,
  ListView,
  LocationsView,
  ProjectOverviewView,
  ShowView,
} from "./views";

const projectsRoutes = [
  {
    path: "",
    element: <ListView />,
    errorElement: <ProjectsError />,
    loader: loaders.projectsLoader,
    children: [
      {
        path: "new",
        action: actions.createProjectAction,
        loader: authorizeLoader(),
        element: <CreateView />,
      },
      {
        path: "delete",
        action: actions.deleteProjectAction,
      },
    ],
  },
  {
    path: ":projectSlug",
    element: <ShowView />,
    id: "project",
    errorElement: <ProjectsError />,
    loader: loaders.projectLoader,
    children: [
      {
        path: "",
        element: <ProjectOverviewView />,
        loader: loaders.projectOverviewLoader,
      },
      {
        path: "process",
        action: actions.processProjectAction,
      },
      {
        path: "location",
        element: <LocationsView />,
        loader: loaders.locationsLoader,
      },
      {
        path: "ai-analysis",
        element: <AiAnalysisView />,
        action: actions.generatePrompt,
      },
      ...statementsRoutes,
    ],
  },
];

export default projectsRoutes;
